export const defaultColumns = [
  {label: 'Nome da permissão', value: 'display_name'},
  {label: 'Descrição', value: 'description'},
  {label: 'Ações', value: 'actions', className: 'w-9'},
]
